import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './components/home/home.component';
import { ProfileComponent } from './components/profile/profile.component';
import { BoardUserComponent } from './components/board-user/board-user.component';
import { PhoneVerificationComponent } from './components/phone-verification/phone-verification.component';
import { EmailVerificationComponent } from './components/email-verification/email-verification.component';
import { BoardAdminComponent } from './components/board-admin/board-admin.component';
import { BookComponent } from './components/book/book.component';
import { BookConfirmComponent } from './components/book-confirm/book-confirm.component';
import { PasswordResetTokenComponent } from './components/user/password/reset-token/password-reset-token.component';
import { PasswordResetComponent } from './components/user/password/reset/password-reset.component';
import { EmailVerifyComponent } from './components/user/email/verify/email-verify.component';
import { LoginComponent } from './components/login/login.component';
import { PhoneUpdateComponent } from './components/user/phone/update/phone-update.component';
import { QrCodeComponent } from './components/qr-code/qr-code.component';
import { UserInfoQrComponent } from './components/user/user-info-qr/user-info-qr.component';
import { PolicyManagementComponent } from './components/user/policy-management/policy-management.component';
import { CheckoutSuccessComponent } from './components/checkout-success/checkout-success.component';
import { UserListComponent } from './components/user/user-list/user-list.component';
import { AdminOrderListComponent } from './components/board-admin/admin-order-list/admin-order-list.component';
import { OfficeListComponent } from './components/office/office-list/office-list.component';
import { RoomListComponent } from './components/room/room-list/room-list.component';
import { WorkPlaceListComponent } from './components/workplace/workplace-list/workplace-list.component';
import { DoorListComponent } from './components/door/door-list/door-list.component';
import { TimeperiodListComponent } from './components/timeperiod/timeperiod-list/timeperiod-list.component';
import {
  BookingPriceListComponent
} from './components/prices/booking-prices/booking-price-list/booking-price-list.component';
import { CouponListComponent } from './components/office-coupons/coupon-list/coupon-list.component';
import { DiscountListComponent } from './components/discount/discount-list/discount-list.component';
import { ZkUserListComponent } from './components/zk/zk-user-list/zk-user-list.component';
import { ZkRtLogComponent } from './components/zk/zk-rt-log/zk-rt-log.component';
import { RelayBoardListComponent } from './components/relay-board/relay-board-list/relay-board-list.component';
import { RelayListComponent } from './components/relay/relay-list/relay-list.component';
import {
  RelayScriptRuleListComponent
} from './components/relay-script-rule/relay-script-rule-list/relay-script-rule-list.component';
import { UserNotificationListComponent } from './components/user/notification/user-notification-list.component';
import { VisitorsManagementComponent } from './components/visitors/visitors-management/visitors-management.component';
import { QuickCardListComponent } from './components/quick-card/quick-card-list/quick-card-list.component';
import { CoffeeUseComponent } from './components/coffee/coffee-use/coffee-use.component';
import { CoffeeConfigListComponent } from './components/coffee/coffee-config-list/coffee-config-list.component';
import { CoffeeMakeComponent } from './components/coffee/coffee-make/coffee-make.component';
import { RoomClosureListComponent } from './components/roomclosure/roomclosure-list/roomclosure-list.component';
import { SensorListComponent } from './components/sensor/sensor-list/sensor-list.component';
import { SubscriptionListComponent } from './components/subscription/subscription-list/subscription-list.component';
import {
  LessonsScheduleListComponent
} from './components/lessons-schedule/lessons-schedule-list/lessons-schedule-list.component';
import {
  BookedLessonsListComponent
} from 'src/app/components/booked-lessons/booked-lessons-list/booked-lessons-list.component';
import {
  SubscriptionCouponsListComponent
} from 'src/app/components/subscription-coupons/subscription-coupons-list/subscription-coupons-list.component';
import { ViewModes } from 'src/app/enums/UsersViewModes';

const adminRoutes: Routes = [
  {
    path: 'users',
    component: UserListComponent,
    data: {
      mode: ViewModes.USERS,
      roles: [
        'ROLE_SUPER_ADMIN',
        'ROLE_ADMIN',
        'ROLE_TEACHER'],
    }
  },
  {
    path: ViewModes.CUSTOMERS,
    component: UserListComponent,
    data: {
      mode: ViewModes.CUSTOMERS,
      roles: [
        'ROLE_USER',
      ],
    }
  },
  { path: 'orders', component: AdminOrderListComponent },
  { path: 'offices', component: OfficeListComponent },
  { path: 'rooms', component: RoomListComponent },
  { path: 'workplaces', component: WorkPlaceListComponent },
  { path: 'doors', component: DoorListComponent },
  { path: 'timeperiods', component: TimeperiodListComponent },
  { path: 'prices', component: BookingPriceListComponent },
  { path: 'office-coupons', component: CouponListComponent },
  { path: 'office-coupons', component: CouponListComponent },
  { path: 'subscription-coupons', component: SubscriptionCouponsListComponent },
  { path: 'discounts', component: DiscountListComponent },
  { path: 'subscriptions', component: SubscriptionListComponent },
  { path: 'lessons-schedule', component: LessonsScheduleListComponent },
  { path: 'booked-lessons', component: BookedLessonsListComponent },
  { path: 'zk/users', component: ZkUserListComponent },
  { path: 'zk/logs', component: ZkRtLogComponent },
  { path: 'relayboards', component: RelayBoardListComponent },
  { path: 'relays', component: RelayListComponent },
  { path: 'sensors', component: SensorListComponent },
  { path: 'relayscriptrules', component: RelayScriptRuleListComponent },
  { path: 'usernotifications', component: UserNotificationListComponent },
  { path: 'policies', component: PolicyManagementComponent },
  { path: 'visitors', component: VisitorsManagementComponent },
  { path: 'quickcards', component: QuickCardListComponent },
  { path: 'coffeeconfigs', component: CoffeeConfigListComponent },
  { path: 'roomclosures', component: RoomClosureListComponent },
  { path: '', redirectTo: '/admin/users', pathMatch: 'full' }
];

const routes: Routes = [
  { path: 'home', component: HomeComponent },
  { path: 'home/:type', component: LoginComponent },
  { path: 'user/profile', component: ProfileComponent },
  { path: 'user', component: BoardUserComponent },
  { path: 'user/:userId/qr', component: UserInfoQrComponent },
  { path: 'admin', component: BoardAdminComponent, children: adminRoutes },
  { path: 'user/phone-verification', component: PhoneVerificationComponent },
  { path: 'user/phone/update', component: PhoneUpdateComponent },
  { path: 'user/email-verification', component: EmailVerifyComponent },
  { path: 'email/verify', component: EmailVerificationComponent },
  { path: 'checkout-success', component: CheckoutSuccessComponent },
  { path: 'qr/:token', component: QrCodeComponent },
  { path: 'book/:officeId', component: BookComponent },
  { path: 'booking-confirmation/:orderId', component: BookConfirmComponent },
  { path: 'password/reset_token', component: PasswordResetTokenComponent },
  { path: 'password/reset', component: PasswordResetComponent },
  { path: 'policy-management', component: PolicyManagementComponent },
  { path: 'visitors', component: VisitorsManagementComponent },
  { path: 'user/coffee', component: CoffeeUseComponent },
  { path: 'coffee/make', component: CoffeeMakeComponent },
  { path: '', redirectTo: 'admin', pathMatch: 'full' },
];

@NgModule({
  exports: [RouterModule],
  imports: [RouterModule.forRoot(routes, { useHash: true })],
})
export class AppRoutingModule {
}
